module.exports = __webpack_public_path__ + "static/img/tagtop1.850c567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tagtop1.png
// module id = gmc6
// module chunks = 1